<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container>
      <v-row class="mb-4">
        <v-col cols="12">
          <h2 v-if="ptoData">
            {{ $t("basics.edit", { type: $t("basics.pto") }) }}
          </h2>
          <h2 v-else>
            {{ $t("basics.new", { type: $t("basics.pto") }) }}
          </h2>
        </v-col>
      </v-row>

      <v-form ref="ptoEditForm">
        <v-row>
          <v-col>
            <v-text-field v-model="startDate" :label="$t('basics.startDate') + '*'" variant="outlined" type="date"
              :min="minStartDate" :max="maxStartDate" placeholder="DD.MM.YYYY"
              :rules="[requiredRule, startDateSmallerRule]"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field v-model="endDate" :label="$t('basics.endDate') + '*'" variant="outlined" type="date"
              :min="minEndDate" :max="maxEndDate" placeholder="DD.MM.YYYY"
              :rules="[requiredRule, startDateSmallerRule]"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat :rules="[requiredRule, max5000]" v-model="comment"
              :label="$t('basics.comment') + '*'"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-switch variant="outlined" flat v-model="stayAvailable" color="primary"
              :label="$t('basics.stayAvailable') + '*'"></v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" @click="confirm()" ref="confirmButton" style="width: 100%">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "ptoEditComponent",

  props: ["refreshDisplay", "ptoData"],

  emits: ["close"],

  data() {
    return {
      startDate: undefined,
      startDatePicker: false,

      endDate: undefined,
      endDatePicker: false,

      stayAvailable: false,

      comment: undefined,

      requiredRule: (value) => !!value || this.$i18n.t("messages.required"),

      validObject: (value) =>
        !value ||
        typeof value == "object" ||
        this.$i18n.t("messages.validSelectionrequired"),
      max5000: (value) =>
        !value ||
        value.length <= 5000 ||
        this.$i18n.t("messages.tooLong", { count: 5000 }),

      startDateSmallerRule: (value) =>
        !this.startDate ||
        !this.endDate ||
        this.startDate <= this.endDate ||
        typeof value == "object" ||
        this.$i18n.t("messages.startDateTooBig"),
    };
  },

  computed: {
    smallCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        default:
          return 6;
      }
    },

    minStartDate() {
      return "2000-01-01"
    },
    maxStartDate() {
      return "9999-12-31"
    },
    minEndDate() {
      if (this.startDate) {
        return (new Date(this.startDate)).toISOString().split('T')[0]
      }

      return "2000-01-01"
    },
    maxEndDate() {

      return "9999-12-31"
    }
  },

  watch: {
    refreshDisplay() {
      if (this.refreshDisplay) {
        this.fetchData();
      }
    },
  },

  methods: {
    normalizeDate(dateStr) {
      return this.$moment(dateStr, ["YYYY-MM-DD", "DD.MM.YYYY"], true).format("YYYY-MM-DD");
    },
    setValues() {
      if (this.ptoData) {
        this.startDate = this.normalizeDate(this.ptoData.start_date);
        this.endDate   = this.normalizeDate(this.ptoData.end_date);

        this.stayAvailable = this.ptoData.stay_available

        this.comment = this.ptoData.comment;
      } else {
        this.startDate = undefined;
        this.endDate = undefined;
        this.comment = undefined;
        this.stayAvailable = false
      }
    },
    getReadableDate(date) {
      if (date) return this.$moment(date).format("DD.MM.YYYY");
      else return undefined;
    },
    async confirm() {
      const { valid } = await this.$refs.ptoEditForm.validate();

      if (valid) {
        this.$emit("loading", true);

        let formData = {
          start_date: this.$moment(this.startDate).format("YYYY-MM-DD"),
          end_date: this.$moment(this.endDate).format("YYYY-MM-DD"),
          comment: this.comment,
          stay_available: this.stayAvailable
        };


        if (this.ptoData && this.ptoData.id) {
          formData["id"] = this.ptoData.id;
          this.patchData(formData);
        } else {
          this.postData(formData);
        }
      }
    },
    postData(formData) {
      this.axios
        .post(this.axios.defaults.baseURL + "calendar/usertodates/post/", formData)
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    patchData(formData) {
      this.axios
        .patch(
          this.axios.defaults.baseURL + "calendar/usertodates/patch/" + formData.id,
          formData
        )
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    fetchData(skipSetting = false) {
      let query = "?internal_users=1";

      if (typeof this.userString == "string" && this.userString.length > 1) {
        query += "&query=" + this.userString;
      }

      if (!this.isUnavailable) {
        query += "&external=1"
      }

      this.axios
        .get(this.axios.defaults.baseURL + "user/users/" + query)
        .then((resp) => {
          this.availUsers = resp.data.results;

          if (!skipSetting) {
            this.setValues()
          }
        })
        .catch((e) => {
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },

  mounted() { },
};
</script>
